module.exports = __webpack_public_path__ + "static/media/aftertop2.a4d0252e.png";